import { ROLES } from '@/constants/roles';

export default [
  {
    path: '/get-price',
    name: 'get_price',
    component: () => import('@/views/pages/GetPrice.vue'),
    meta: {
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN, ROLES.CUSTOMER_MANAGER, ROLES.CUSTOMER_USER],
      verticalMenu: {
        title: 'Get Price',
        icon: 'DollarSignIcon'
      }
    }
  }
];
